var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, InsertLinkOutlined } from '@mui/icons-material';
import { LinearProgress, Typography, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { v4 } from 'uuid';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../assets/customIcons';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiStack } from '../../../components';
import StatusColor from '../../../components/atoms/statusColor';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showNewNotification } from '../../../redux/commonSlice';
import { resetState } from '../../../redux/crudSlice';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate, isLoadingState } from '../../../utils/utils';
import WPIWorkOrderDetails from '../components/wpiWorkOrderDetails';
import { CreateWorkPurchaseInvoiceAPICall, GetWorkPurchaseOrderDetailsAPICall, GetWorkPurchaseOrderListAPICall, OrganizationAddressListAPICall, PaymentMethodsListAPICall, PaymentTermsListAPICall, purchaseInvoiceAttachmentDelete, SupplierListWPOUrlAPICall, uploadPurchaseInvoiceAttachment } from '../services/apiCall';
import { WorkPurchaseInvoiceKeys, WorkPurchaseInvoiceMandatoryFeilds, WorkPurchaseInvoiceStatusEnum, WPIApiKeys } from '../services/entity';
import WorkOrderDetailTabMobView from '../components/workOrderDetailsMobView';
import GrandTotalPopup from './grandTotalPopup';
import { useAppDispatch } from '../../../store/hooks';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
function CreateWorkPurchaseInvoice() {
    var _this = this;
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$profilePersonal;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var id = useParams().id;
    var mode = searchParams.get('mode');
    var crud = useSelector(function (state) { return state.crud; });
    var data = crud[WorkPurchaseInvoiceKeys === null || WorkPurchaseInvoiceKeys === void 0 ? void 0 : WorkPurchaseInvoiceKeys.WorkPurchaseInvoiceDetails] || crud[WorkPurchaseInvoiceKeys === null || WorkPurchaseInvoiceKeys === void 0 ? void 0 : WorkPurchaseInvoiceKeys.Get];
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isDisabled = mode == 'edit' && (data === null || data === void 0 ? void 0 : data.StatusName) !== WorkPurchaseInvoiceStatusEnum.Draft;
    var GetWorkPurchaseOrderList = function (params) { return GetWorkPurchaseOrderListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            "OrganizationId": UserOrganization,
            "ParentOrganizationId": UserParentOrganization
        })
    })); };
    var getShippingAddressList = function (params) {
        var _params$state;
        return OrganizationAddressListAPICall(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                OrganizationId: params === null || params === void 0 || (_params$state = params.state) === null || _params$state === void 0 ? void 0 : _params$state.SupplierId
            })
        }));
    };
    var getSupplierByOrganization = function (params) { return SupplierListWPOUrlAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            ParentOrganizationId: "04945692-d924-4f9d-ae24-83b46eeb5867"
        })
    })); };
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var dispatch = useAppDispatch();
    var handlePopupAction = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: GrandTotalPopup,
                        // componentProps: { message: "Are you sure you want to delete this record?" },
                        containerProps: {
                            fullWidth: true
                        }
                    }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var General = [{
            type: FormItemTypes.CardComponent,
            name: 'GeneralTabs',
            label: 'General Tabs',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic details',
            elements: [id ? {
                    type: FormItemTypes.TextInput,
                    name: 'DocumentNumber',
                    label: 'Work purchase order',
                    value: null,
                    required: true,
                    disabled: true
                } : {
                    type: FormItemTypes.SearchSelect,
                    name: 'ParentId',
                    label: 'Work purchase order',
                    placeholder: 'Search work purchase order',
                    value: null,
                    valueExpr: "id",
                    displayExpr: "DocumentNumber",
                    getListData: GetWorkPurchaseOrderList,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, GetWorkPurchaseOrderDetailsAPICall({
                                        request: {
                                            PurchaseOrderId: currValue === null || currValue === void 0 ? void 0 : currValue.id
                                        }
                                    })];
                                case 1:
                                    res = _a.sent();
                                    return [2 /*return*/, _objectSpread(_objectSpread({}, res), {}, {
                                            SupplierId: res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.SupplierId,
                                            SupplierName: res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.SupplierName,
                                            OrderDate: res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.OrderDate,
                                            DeliveryLocationId: res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.DeliveryLocationId,
                                            WPODetails: res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.WPODetails,
                                            Attachments: res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.Attachments,
                                            WorkPurchaseOrder: currValue
                                        })];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SupplierId',
                    label: 'Supplier',
                    valueExpr: "id",
                    displayExpr: "Name",
                    required: true,
                    getListData: getSupplierByOrganization,
                    setFormState: function (formValues, currValue, field) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    Supplier: currValue,
                                    DeliveryLocationId: null,
                                    WPODetails: [{
                                            id: 1
                                        }]
                                }];
                        });
                    }); }
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'OrderDate',
                    label: 'Order date',
                    required: true,
                    disableFuture: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'InvoiceDate',
                    label: 'Invoice date',
                    value: null,
                    required: true,
                    disableFuture: true,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'DeliveryDate',
                    label: 'Delivery date',
                    value: null
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PaymentTermId',
                    label: 'Payment terms',
                    value: null,
                    valueExpr: "id",
                    displayExpr: "Name",
                    getListData: PaymentTermsListAPICall
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PaymentMethodId',
                    label: 'Payment method',
                    value: null,
                    valueExpr: "id",
                    getListData: PaymentMethodsListAPICall,
                    displayExpr: "Name"
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DeliveryLocationId',
                    label: 'Shipping address',
                    placeholder: 'Select shipping address',
                    value: null,
                    valueExpr: "id",
                    displayExpr: "CityName",
                    getListData: getShippingAddressList,
                    apiKey: WorkPurchaseInvoiceKeys.OrganizationAddressList,
                    setFieldProps: function (formValues, value) {
                        var _formValues$Supplier, _formValues$Supplier2;
                        // dispatch(deleteState({ key: `${WorkPurchaseInvoiceKeys.OrganizationAddressListDynamicKey}-${formValues?.Supplier?.Name}` }))
                        return {
                            type: this.type,
                            disabled: !(formValues !== null && formValues !== void 0 && (_formValues$Supplier = formValues.Supplier) !== null && _formValues$Supplier !== void 0 && _formValues$Supplier.Name),
                            apiKey: "".concat(WorkPurchaseInvoiceKeys.OrganizationAddressListDynamicKey, "-").concat(formValues === null || formValues === void 0 || (_formValues$Supplier2 = formValues.Supplier) === null || _formValues$Supplier2 === void 0 ? void 0 : _formValues$Supplier2.Name)
                        };
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'InvoiceNo',
                    label: 'WP Invoice number',
                    placeholder: 'Enter WP invoice number',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    value: null,
                    required: true
                }]
        }];
    var WorkOrder = [{
            type: FormItemTypes.Custom,
            name: "WPODetails",
            label: '',
            value: null,
            columnSize: 12,
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(WorkPurchaseInvoiceMandatoryFeilds)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: WorkPurchaseInvoiceMandatoryFeilds[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            element: IS_MOBILE ? WorkOrderDetailTabMobView : WPIWorkOrderDetails
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: 'GrandTotal',
                    columnSize: 4,
                    xs: 12,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            flexGrow: 1
                        },
                        fontWeight: "bold",
                        textAlign: "left"
                    }, "Grands Total"),
                    variant: 'outlined',
                    fullWidth: true,
                    onClick: function () { return handlePopupAction(); },
                    sx: {
                        justifyContent: 'space-between',
                        bgcolor: 'rgba(0,0,0,0.05)',
                        fontWeight: 'bold',
                        color: systemColor.secondary
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _totalAmt$toFixed, _totalAmt;
                        var totalAmt = 0;
                        var totalQty = 0;
                        if (Array.isArray(formValues === null || formValues === void 0 ? void 0 : formValues.WPODetails)) {
                            var _formValues$WPODetail, _formValues$WPODetail2;
                            totalAmt = formValues === null || formValues === void 0 || (_formValues$WPODetail = formValues.WPODetails) === null || _formValues$WPODetail === void 0 ? void 0 : _formValues$WPODetail.reduce(function (acc, data) {
                                return acc + ((data === null || data === void 0 ? void 0 : data.TotalAmount) || 0);
                            }, 0);
                            totalQty = formValues === null || formValues === void 0 || (_formValues$WPODetail2 = formValues.WPODetails) === null || _formValues$WPODetail2 === void 0 ? void 0 : _formValues$WPODetail2.reduce(function (acc, data) {
                                return acc + (data === null || data === void 0 ? void 0 : data.RequestedQuantity);
                            }, 0);
                        }
                        return {
                            type: this.type,
                            startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ChevronRightRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null),
                            endIcon: "\u20B9 ".concat((_totalAmt$toFixed = (_totalAmt = totalAmt) === null || _totalAmt === void 0 ? void 0 : _totalAmt.toFixed(2)) !== null && _totalAmt$toFixed !== void 0 ? _totalAmt$toFixed : '00.00')
                        };
                    },
                    setFormState: function (formValues, e, field) {
                        return {
                            Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                        };
                    }
                }]
        }];
    var Account = [];
    var AdditionalInformation = [{
            type: FormItemTypes.CardComponent,
            name: 'AdditionalInfo',
            label: 'Notes & attachments',
            value: null,
            variant: 'outlined',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    spacing: 2,
                    marginTop: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Comment/notes (0/200 characters)',
                            placeholder: 'Enter comments...',
                            value: null,
                            multiline: true,
                            maxLength: 200,
                            minRows: 2,
                            columnSize: 6,
                            xs: 12,
                            sm: 6,
                            disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                            setFieldProps: function (formValues, value) {
                                var _value$length;
                                return {
                                    type: this.type,
                                    label: "Comment/notes (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 characters)")
                                };
                            }
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                            value: [],
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: WorkPurchaseInvoiceKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadPurchaseInvoiceAttachment,
                            deleteAttachmentAPI: purchaseInvoiceAttachmentDelete
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General,
            containerProps: {
                paddingX: 2
            }
        }, {
            id: '1',
            label: 'Work order details',
            elements: WorkOrder,
            containerProps: {
                paddingX: 2
            }
        }, {
            id: '2',
            label: 'Additional info',
            elements: AdditionalInformation,
            containerProps: {
                paddingX: 2
            }
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () {
                            dispatch(resetState(WPIApiKeys)), navigate('/workPurchaseInvoice');
                        }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: mode == 'edit' ? 'Work purchase invoice' : 'New work purchase invoice',
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function () { return data !== null && data !== void 0 && data.StatusName ? /*#__PURE__*/ React.createElement(MuiStack, {
                        sx: {
                            border: "1px solid #DEE4EB",
                            borderRadius: "6px",
                            gap: "5px",
                            padding: "3px 8px"
                        },
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement(StatusColor, {
                        status: ''
                    }), /*#__PURE__*/ React.createElement(Typography, {
                        id: "statusKeyId",
                        variant: "h6"
                    }, data === null || data === void 0 ? void 0 : data.StatusName)) : /*#__PURE__*/ React.createElement(React.Fragment, null); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentNumber',
                            label: 'DOC NO: ',
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 500,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'DocumentDate',
                            label: 'DOC DATE: ',
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.DocumentDate);
                            },
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 500,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Quick Links",
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            sx: {
                px: 2,
                gap: 2
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    columnSize: 0,
                    variant: 'contained',
                    color: 'primary',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState(WPIApiKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        createKey: WorkPurchaseInvoiceKeys.Create,
        createFormAPI: CreateWorkPurchaseInvoiceAPICall,
        createRequest: {
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId,
            Attachments: [],
            TotalAmount: 0,
            ParentOrganizationId: UserParentOrganization !== null && UserParentOrganization !== void 0 ? UserParentOrganization : '',
            OrganizationId: UserOrganization !== null && UserOrganization !== void 0 ? UserOrganization : '',
            DocumentDate: new Date().toISOString(),
            Status: "Draft",
            Type: "WorkPurchaseInvoice"
        },
        getFormAPI: GetWorkPurchaseOrderDetailsAPICall,
        getKey: WorkPurchaseInvoiceKeys === null || WorkPurchaseInvoiceKeys === void 0 ? void 0 : WorkPurchaseInvoiceKeys.Get,
        getRequest: {
            PurchaseOrderId: id
        },
        updateFormAPI: CreateWorkPurchaseInvoiceAPICall,
        updateRequest: {
            PurchaseOrderId: id !== null && id !== void 0 ? id : ''
        },
        onClose: function () {
            dispatch(showNewNotification({
                isOpen: true,
                title: 'Success',
                message: 'Saved Successfully',
                type: 'success'
            }));
            navigate(-1);
        }
    }));
}
export default CreateWorkPurchaseInvoice;
